import Logger from './logger';

const log = new Logger();

/**
 * parseHash:
 * Returns an object from the parsed window hash
 *
 * @returns {{}}
 */
export default () => {
  const phase1 = window.location.hash.slice(3).split('&');
  const hash = phase1.reduce((hashObj, str) => {
    let [key, value] = str.split('='); //eslint-disable-line
    if (key === 'state') {
      value = JSON.parse(decodeURIComponent(value));
    }
    hashObj[key] = value;
    return hashObj;
  }, {});

  log.debug({
    category: 'helpers',
    message: 'parseHash',
    data: hash
  });

  return hash;
};
